import Span from '@jumbo/shared/Span';
import { ViewList } from '@mui/icons-material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Autocomplete, Box, Button, ButtonGroup, Card, Chip, Divider, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { getObjectListByPropertyApi, putUpdateObjectApi } from 'api/general';
import AddUpdateAgendaDialog from 'app/components/Dialog/AddUpdateAgendaDialog';
import { getLocaleDateWithTimeCustom, getUserFullName, stripHTMLTags, updateSortedAgendaList } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE } from 'app/utils/constants/customConstant';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentAgenda, showAgendaSnackbar } from 'stores/meeting';
import config, { agendaCardColor, agendaCardTextColor, ykUnitId } from '../../../config';
import AgendaFileDialog from '../Dialog/AgendaFileDialog';
import ReportMenuGroup from '../ReportMenuGroup';
import AgendaReviewListTable from '../Table/AgendaReviewListTable';
import DashboardVoteListTable from '../Table/DashboardVoteListTable';
import CustomTooltip from '../Tooltip/CustomTooltip';

export const AgendaReviewVoteContext = React.createContext({ reviewsByDecisionId: {}, votesByDecisionId: {} });
export const AgendaProcessingContext = React.createContext({ setProcessing: () => {} });

function AgendaCard(props) {
    const wrapRef = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = wrapRef.current;
        if (!el) {
            return;
        }

        let root = el.parentElement;
        while (root && root !== document.body) {
            const overflowY = getComputedStyle(root).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') {
                break;
            }
            root = root.parentElement;
        }
        if (!root || root === document.body) {
            root = null;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, { root, rootMargin: '300px' });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={wrapRef} style={inView ? undefined : { minHeight: 220 }}>
            {inView ? <AgendaCardContent {...props} /> : null}
        </div>
    );
}

function AgendaCardContent({ agenda, index, handleAgendaSorting, agendas, maxDecisionNo, minDecisionNo, handleDelete }) {

    const dispatch = useDispatch();
    const [decisionNo, setDecisionNo] = useState(agenda.decisionNo);
    const { data: userList } = useSelector(state => state.user);
    const subjectList = useSelector(state => state.subject.data || []);
    const [agendaobj, setAgendaobj] = useState(agenda);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const { reviewsByDecisionId, votesByDecisionId } = useContext(AgendaReviewVoteContext);
    const { setProcessing } = useContext(AgendaProcessingContext);

    const runWithProcessing = async (fn) => {
        setProcessing(true);
        try {
            await fn();
        } finally {
            setProcessing(false);
        }
    };
    const departmentList = config.departments;
    const currentAgendaList = useSelector((state) => state.meeting.currentAgendaList);
    const [agendaFileList, setAgendaFileList] = useState([]);
    const [fileDialogStatus, setFileDialogStatus] = useState(false);
    const [editingSubject, setEditingSubject] = useState(false);
    const [editingDepartment, setEditingDepartment] = useState(false);
    const [subjectMenuOpen, setSubjectMenuOpen] = useState(false);
    const [departmentMenuOpen, setDepartmentMenuOpen] = useState(false);

    const reviews = reviewsByDecisionId[agenda.id] || [];
    const agendaVoteList = votesByDecisionId[agenda.id] || [];

    useEffect(() => {
        setAgendaobj(agenda);
        setDecisionNo(agenda.decisionNo);
        setPendingSubjectId(agenda.subjectId);
        setPendingDepartment(agenda.department);
        setEditingSubject(false);
        setEditingDepartment(false);
        setSubjectMenuOpen(false);
        setDepartmentMenuOpen(false);
    }, [agenda]);

    useEffect(() => {
        setDecisionNo(agenda.decisionNo);
    }, [agenda.decisionNo]);

    //sıralama fonksiyonlari

    const handleDecisionNoChange = (event) => {
        const newDecisionNo = Number(event.target.value);
        setDecisionNo(newDecisionNo);
    };
    const handleSorting = (index, agenda, upDown) => {

        handleAgendaSorting(index, agenda, upDown)
    };

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter') {
            await runWithProcessing(async () => {
                const newAgenda = { ...agenda, decisionNo: Number(decisionNo) };
                dispatch(await updateSortedAgendaList(currentAgendaList, "change", newAgenda, true));
            });
        }
    };

    const handleUpdateClick = (item) => {
        dispatch(setCurrentAgenda(item));
        setAddAgendaDialogStatus(true);
    };


    const closeFileDialog = () => {
        setFileDialogStatus(false);
    };
    const handleFileButtonClick = (agenda) => {
        dispatch(setCurrentAgenda(agenda));
        setFileDialogStatus(true)

        let agendaFiles = [];
        const getAPI = async () => {

            const res = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", agenda.id) // ???? ornek id 13643
            agendaFiles = res.data
            agendaFiles.forEach(element => {
                const user = userList.find(item => item.id === element.adminUserId);
                element.user = user
            });
            setAgendaFileList(agendaFiles)
        };
        getAPI();
    }

    const [addAgendaDialogStatus, setAddAgendaDialogStatus] = useState(false);
    const closeDialog = () => {
        setAddAgendaDialogStatus(false);
        dispatch(setCurrentAgenda(null));
    };


    const handleSelectChange = async (newValues) => {
        await runWithProcessing(async () => {
            const updatedAgenda = {
                ...agendaobj,
                ...newValues
            };
            let user = updatedAgenda.user;
            delete updatedAgenda.user;
            const result = await putUpdateObjectApi(DECISION, updatedAgenda);
            if (result.status) {
                updatedAgenda.user = user;
                setAgendaobj(updatedAgenda);
                dispatch(await updateSortedAgendaList(currentAgendaList, "update", updatedAgenda, true));
                dispatch(showAgendaSnackbar({
                    message: `${updatedAgenda.decisionNo} numaralı gündemde değişiklik yapıldı.`,
                    severity: 'info'
                }));
            }
        });
    };    const [pendingSubjectId, setPendingSubjectId] = useState(agendaobj.subjectId);
    const [pendingDepartment, setPendingDepartment] = useState(agendaobj.department);

    const availableSubjectList = currentMeeting?.unitId === ykUnitId
        ? subjectList.filter((subject) => subject.isVisibleYk === 1)
        : subjectList;

    return (
        <Card
            elevation={0}
            sx={{
                // boxShadow: 'none',
                backgroundColor: agendaCardColor,
                width: '99%',
                borderRadius: 5,
                margin: 1,
                paddingTop: '20px',
                border: '1px solid #e0e0e0',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: 2,
                    borderBottomColor: 'divider',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: '100%',
                }}
            >


                <Grid container spacing={0} sx={{ width: '100%', marginBottom: 1, padding: 0 }}>
                    <Grid item xs={12} md={1} lg={1}>
                        <Grid container sx={{ margin: 0, padding: 0 }}>
                            <Grid item xs={12}>
                                <ButtonGroup>
                                    <IconButton
                                        onClick={() => handleSorting(index, agenda, 'up')}
                                        disabled={index === 0}
                                    >
                                        <ArrowUpwardIcon sx={{  }} />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => handleSorting(index, agenda, 'down')}
                                        disabled={index === agendas.length - 1}
                                    >
                                        <ArrowDownwardIcon sx={{  }} />
                                    </IconButton>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={1} lg={1}>
                        <TextField
                            value={decisionNo}
                            onChange={handleDecisionNoChange}
                            onKeyDown={handleKeyDown}
                            label="Gündem No"
                            variant="outlined"
                            type="number"
                            size="small"
                            fullWidth
                            sx={{
                                width: '80%',
                                margin: 0,
                                '& .MuiInputBase-input': {  },
                                '& .MuiInputLabel-root': {  },
                            }}
                        />
                        ({agenda.id})
                    </Grid>

                    {/* SUBJECT AUTOCOMPLETE */}
                    <Grid item xs={12} md={3} lg={3}>
                        {editingSubject ? (
                            <Autocomplete
                                sx={{ width: '100%', padding: 0, margin: 0, '& .MuiSelect-select': { height: 'auto', minHeight: 'unset' } }}
                                id={`autocomplete-subject-${agenda.id}`}
                                options={availableSubjectList}
                                value={availableSubjectList.find(option => option.id === pendingSubjectId) || null}
                                open={subjectMenuOpen}
                                onOpen={() => setSubjectMenuOpen(true)}
                                onClose={() => setSubjectMenuOpen(false)}
                                onChange={(e, newValue) => {
                                    setPendingSubjectId(newValue ? newValue.id : 0);
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        handleSelectChange({ subjectId: pendingSubjectId });
                                    }
                                }}
                                size="small"
                                autoFocus
                                openOnFocus
                                getOptionLabel={option => option.name}
                                ListboxProps={{ style: { lineHeight: 1 } }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        autoFocus
                                        variant="outlined"
                                        placeholder="Konu seçiniz"
                                        sx={{ width: '90%' }}
                                        InputProps={{ ...params.InputProps, style: {  } }}
                                    />
                                )}
                            />
                        ) : (
                            <TextField
                                size="small"
                                value={availableSubjectList.find(option => option.id === pendingSubjectId)?.name || ''}
                                placeholder="Konu seçiniz"
                                onClick={() => { setEditingSubject(true); setSubjectMenuOpen(true); }}
                                onFocus={() => { setEditingSubject(true); setSubjectMenuOpen(true); }}
                                InputProps={{ readOnly: true }}
                                sx={{
                                    width: '90%',
                                    '& .MuiInputBase-input': { cursor: 'pointer' },
                                }}
                            />
                        )}
                    </Grid>

                    {/* DEPARTMENT AUTOCOMPLETE */}
                    <Grid item xs={12} md={4} lg={3}>
                        {editingDepartment ? (
                            <Autocomplete
                                multiple
                                sx={{ size: 'medium', width: '100%', padding: 0, margin: 0, '& .MuiSelect-select': { height: 'auto', minHeight: 'unset' } }}
                                id={`department-autocomplete-${agenda.id}`}
                                options={departmentList}
                                open={departmentMenuOpen}
                                onOpen={() => setDepartmentMenuOpen(true)}
                                onClose={() => setDepartmentMenuOpen(false)}
                                value={
                                    pendingDepartment
                                        ? departmentList.filter(option => pendingDepartment.split(',').map(dep => dep.trim()).includes(option.name))
                                        : []
                                }
                                onChange={(e, newValue) => {
                                    setPendingDepartment(newValue.length ? newValue.map(v => v.name).join(', ') : '');
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        handleSelectChange({ department: pendingDepartment });
                                    }
                                }}
                                size="small"
                                autoFocus
                                openOnFocus
                                getOptionLabel={option => option.name}
                                ListboxProps={{ style: { lineHeight: 1 } }}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip key={option.name} label={option.name} size="medium" {...getTagProps({ index })} sx={{ height: '18px', margin: '2px', padding: '2px' }} />
                                ))}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        autoFocus
                                        variant="outlined"
                                        sx={{ width: '90%' }}
                                        InputProps={{ ...params.InputProps, style: { padding: '6px' } }}
                                    />
                                )}
                            />
                        ) : (
                            <Box
                                onClick={() => { setEditingDepartment(true); setDepartmentMenuOpen(true); }}
                                sx={{
                                    width: '90%',
                                    minHeight: 40,
                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                    borderRadius: 1,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    px: 0.5,
                                    py: 0.25,
                                    cursor: 'pointer',
                                    '&:hover': { borderColor: 'text.primary' },
                                }}
                            >
                                {pendingDepartment
                                    ? pendingDepartment.split(',').map((dep) => dep.trim()).filter(Boolean).map((name) => (
                                        <Chip key={name} label={name} size="medium" sx={{ height: '18px', margin: '2px', padding: '2px' }} />
                                    ))
                                    : (
                                        <Typography sx={{ color: 'text.secondary', pl: 1 }}>
                                            Birim seçiniz
                                        </Typography>
                                    )}
                            </Box>
                        )}
                    </Grid>

                    <Grid item xs={12} md={3} lg={2}>
                        <span style={{ color: agendaCardTextColor }}>
                            {getLocaleDateWithTimeCustom('tr', agenda.pdate)}
                        </span>
                    </Grid>



                    <Grid item xs={2} md={1} lg={2} >

                        <CustomTooltip
                            placement="top"
                            arrow
                            title={
                                <React.Fragment>
                                    <div
                                        style={{
                                            width: '100%',
                                            maxWidth: '400px',
                                            // height: '100%',


                                        }}
                                    >
                                        <DashboardVoteListTable agendaVotes={agendaVoteList} otherScroll={false} />
                                    </div>
                                </React.Fragment>
                            }
                        >
                            <ViewList color="warning" sx={{ marginRight: 3 }} />
                        </CustomTooltip>

                        <CustomTooltip
                            placement="top"
                            arrow
                            title={
                                <React.Fragment>
                                    <div
                                        style={{
                                            width: '100%',
                                            maxWidth: '600px',
                                            maxHeight: '400px',
                                            color: 'black',
                                        }}
                                    >
                                        <Grid container direction="column">
                                            <Grid item>
                                                {(() => {
                                                    const user = userList.find(x => x.id === Number(agenda.adminUserId));

                                                    return (
                                                        <Grid item>
                                                            <strong style={{ color: 'black' }}>Kullanıcı:</strong> {getUserFullName(user)}
                                                        </Grid>
                                                    );
                                                })()}


                                            </Grid>
                                            <Grid item>
                                                <strong style={{ color: 'black' }}>Ek Gündem:</strong> {agenda.supp}
                                            </Grid>
                                            <Grid item>
                                                <strong style={{ color: 'black' }}>İlke Kararı:</strong> {agenda.principle}
                                            </Grid>
                                            <Grid item>
                                                <strong style={{ color: 'black' }}>Yaysis Id:</strong> {agenda.yaysisMeetingId}
                                            </Grid>
                                            <Grid item>
                                                <strong style={{ color: 'black' }}>Says Id:</strong> {agenda.saysMeetingId}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </React.Fragment>
                            }
                        >
                            <ViewList color="info" sx={{  }} />
                        </CustomTooltip>
                    </Grid>

                </Grid>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    margin: 0,
                }}
            >
                <Stack
                    flex={1}
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={0}
                    pr={2}
                >
                    <Span sx={{ width: '65%', margin: 0 }}>
                        <Grid container spacing={0} sx={{ margin: 0 }}>
                            <Grid item xs={1} />
                            <Grid item xs={11}>
                                <Grid item xs={12}>
                                    <Typography color="primary.main" mt={1}
                                        sx={{
                                            }}>
                                        Gündem Maddesi  {agenda.supp === "Evet" ? "(Ek Gündem)" : ""}
                                    </Typography>
                                    <Typography sx={{ whiteSpace: 'pre-line', color: agendaCardTextColor }}>
                                        {stripHTMLTags(agenda.agenda)}

                                    </Typography>

                                </Grid>
                                <Grid item xs={12}>
                                    <Typography color="primary.main" mt={1} sx={{  }}>
                                        Karar
                                    </Typography>
                                    <Typography sx={{ whiteSpace: 'pre-line', color: agendaCardTextColor }}>
                                        {stripHTMLTags(agenda.decision)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Span>

                    <Span sx={{ width: '30%', margin: 0 }}>
                        <Grid container spacing={1} sx={{ marginLeft: '10px' }}>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item>
                                        <CustomTooltip
                                            placement="top"
                                            arrow
                                            title={
                                                <div >
                                                    <AgendaReviewListTable agendaReviews={reviews} />
                                                </div>
                                            }
                                        >
                                            <Typography
                                                color="primary.main"
                                                sx={{
                                                    marginY: 1,
                                                    cursor: 'pointer',
                                                    '&:hover': { color: 'secondary.main' },
                                                }}
                                            >
                                                Değerlendirme Sonuçları
                                            </Typography>
                                        </CustomTooltip>
                                    </Grid>
                                </Grid>





                                {reviews.length > 0 ? (
                                    (() => {
                                        let totalChars = 0;
                                        const items = [];

                                        for (let i = 0; i < reviews.length; i++) {
                                            const review = reviews[i];
                                            const fullName = getUserFullName(review.user);
                                            const reviewText = review.info

                                            const lineText = `${fullName}: ${reviewText}`;

                                            if (totalChars + lineText.length > 250) {
                                                const remaining = 250 - totalChars;
                                                if (remaining > 0) {

                                                    const partialLine = lineText.slice(0, remaining) + "...";
                                                    items.push(
                                                        <Grid container key={i}>
                                                            <Grid item xs={12}>
                                                                <Typography sx={{ color: agendaCardTextColor }}>
                                                                    {partialLine}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                }
                                                break;
                                            } else {
                                                items.push(
                                                    <Grid container key={i}>
                                                        <Grid item xs={12}>
                                                            <Typography sx={{ color: agendaCardTextColor }}>
                                                                {fullName}
                                                                <Typography
                                                                    component="span"
                                                                    sx={{  }}
                                                                    fontStyle="italic"
                                                                    color="text.secondary"
                                                                >
                                                                    : {reviewText}
                                                                </Typography>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                );
                                                totalChars += lineText.length;
                                            }
                                        }
                                        return items;
                                    })()
                                ) : (
                                    <Typography sx={{ color: agendaCardTextColor }} variant="body2">
                                        Değerlendirme yapılmamıştır.
                                    </Typography>
                                )}




                            </Grid>
                        </Grid>
                    </Span>

                    <Span sx={{ width: '5%', ml: 1, mt: 1 }}>
                        <Grid
                            container
                            spacing={0.5}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item xs={12}>
                                <Stack direction="column" spacing={0.5}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleFileButtonClick(agenda)}
                                        sx={{ padding: '4px' }}
                                    >
                                        Dosyalar
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => handleUpdateClick(agenda)}
                                        sx={{ padding: '4px' }}
                                    >
                                        Güncelle
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={() => handleDelete(agenda)}
                                        sx={{ padding: '4px' }}
                                    >
                                        Sil
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="warning"
                                        size="small"
                                        onClick={() => handleDelete(agenda, "pending")}
                                        sx={{ padding: '4px' }}
                                    >
                                        Askıya Al
                                    </Button>
                                    <ReportMenuGroup meeting={currentMeeting} decisionId={agenda.id} decisionNo={agenda.decisionNo} type="agenda" iconType='button' />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Span>

                </Stack>
            </Box>

            {
                fileDialogStatus && (
                    <AgendaFileDialog
                        agendaFileList={agendaFileList}
                        setAgendaFileList={setAgendaFileList}
                        onClose={closeFileDialog}
                        open={fileDialogStatus}
                        selectedAgenda={agenda}
                    />
                )
            }
            {addAgendaDialogStatus && (
                <AddUpdateAgendaDialog
                    open={addAgendaDialogStatus}
                    onClose={closeDialog}
                />
            )}
        </Card >
    );
}
const style = document.createElement('style');
style.innerHTML = `
        .swal-container-custom {
            z-index: 10000 !important;
        }
    `;
document.head.appendChild(style);

export default AgendaCard;

